<template>
  <div class="search-bar bg-blue-4">
    <div class="search-bar--field container">
      <i class="fal fa-search text-gray-1 mr-m text--xl"></i>
      <input
        class="text-gray-1 text--xl"
        :placeholder="$device.mobile ? 'Search' : 'Search Printed Materials'"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"]
};
</script>

<style lang="stylus" scoped>
.search-bar
    height 130px
    _flex(row, nowrap, center, center)
    +mobile()
      height 80px
    &--field
        _flex(row, nowrap, center, flex-start)
        input
            border none
            flex 1
            // border-bottom 1px solid gray_1
            background transparent
            padding-bottom 5px
            outline 0
            &::placeholder
                color gray_1
                transition color 0.2s ease-out
            &:focus
                outline 0
                &::placeholder
                    color rgba(gray_1, 0.6)
</style>
